const certificates = [
    {
        title: "B.S. Computer Science Diploma",
        pdf: "/assets/certificates/eDiploma.pdf",
        type: "pdf",
    },
    {
        title: "CodePath Intermediate Technical Interview Prep",
        pdf: "/assets/certificates/TIP.pdf",
        type: "pdf",
    },
    {
        title: "CMU Computer Vision",
        pdf: "/assets/certificates/computervisionCertificate.pdf",
        type: "pdf",
    },
    {
        title: "Intro to Applied Data Analytics",
        pdf: "https://www.credential.net/b8c8897b-7a62-4358-997d-1b7addd0e239#acc.kfhEQs3g",
        type: "external",
    },
    {
        title: "Tableau Certification",
        pdf: "https://www.credential.net/fd1fa7b0-7775-4048-b5cc-2ce6c43954b2#acc.2W7pwUl5",
        type: "external",
    },
];

export default certificates;
